module.exports = __webpack_public_path__ + "2357b8fda071f219e6472a79d3cf4ad6.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/dirty-fightin.mp4
// module id = 628
// module chunks = 0